import axios from '@/axios'
import modelService from '@/services/model'
import authService from '@/services/authentication'

export default {

  create: (cbOk, cbErr, email, password) => {
    // NOTE: We send the redirect_url so that the email that goes out, has a link back to the correct vue path
    // The API will tack on a token, call back to Vue and that will present a form to confirm the new account
    // NOTE: location.origin includes the protocol and port live http://example.com:1234
    axios.post('/user/registrations.json', {email: email, password: password, redirect_url: location.origin + '/confirm-registration'})
      .then(response => {
        if (cbOk) cbOk(response)
      })
      .catch(err => {
        if (cbErr) cbErr(err)
      })
  },

  show: (cbOk, cbErr, token) => {
    return modelService.show(cbOk, cbErr, `/user/registrations/${token}.json`)
  },

  confirm (cbOk, cbErr, token) {
    axios.post(`/user/registrations/${token}/confirm.json`, {})
      .then(response => {
        authService.setAuthentication(cbOk, cbErr, response)
      })
      .catch(err => {
        if (cbErr) cbErr(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/registration.js